var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakerListening(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2901_16090)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_2901_16090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0556 7C13.3336 7 12.6412 7.30728 12.1307 7.85425C11.6202 8.40122 11.3334 9.14306 11.3334 9.91659V14.1945C11.3334 14.968 11.6202 15.7099 12.1307 16.2568C12.6412 16.8038 13.3336 17.1111 14.0556 17.1111C14.7776 17.1111 15.47 16.8038 15.9805 16.2568C16.491 15.7099 16.7778 14.968 16.7778 14.1945V9.91659C16.7778 9.14306 16.491 8.40122 15.9805 7.85425C15.47 7.30728 14.7776 7 14.0556 7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5638 21V19.1125C11.0063 18.8836 9.00015 16.8871 9.00015 14.4656C8.99854 14.4051 9.01006 14.3448 9.03404 14.2884C9.05802 14.232 9.09397 14.1806 9.13978 14.1373C9.18559 14.0939 9.24033 14.0595 9.30077 14.0359C9.36122 14.0124 9.42615 14.0003 9.49174 14.0003C9.55733 14.0003 9.62226 14.0124 9.68271 14.0359C9.74315 14.0595 9.79789 14.0939 9.8437 14.1373C9.88951 14.1806 9.92546 14.232 9.94944 14.2884C9.97342 14.3448 9.98494 14.4051 9.98333 14.4656C9.98333 16.5395 11.8102 18.2266 14.0555 18.2266C16.3009 18.2266 18.1278 16.5392 18.1278 14.4654C18.1261 14.4048 18.1377 14.3445 18.1617 14.2881C18.1856 14.2318 18.2216 14.1804 18.2674 14.137C18.3132 14.0936 18.3679 14.0592 18.4284 14.0357C18.4888 14.0121 18.5538 14 18.6194 14C18.6849 14 18.7499 14.0121 18.8103 14.0357C18.8708 14.0592 18.9255 14.0936 18.9713 14.137C19.0171 14.1804 19.0531 14.2318 19.0771 14.2881C19.101 14.3445 19.1126 14.4048 19.1109 14.4654C19.1109 16.8868 17.1051 18.8834 14.5473 19.1125V21H13.5638Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2901_16090",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.689409 0 0 0 0 0.017985 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2901_16090"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2901_16090",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2901_16090",
    x1: 14,
    y1: 4,
    x2: 14,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerListening);
export default __webpack_public_path__ + "static/media/speaker_listening.442c406f824242c291e6104b0a0adea6.svg";
export { ForwardRef as ReactComponent };